<permission-checker [roles]="roles">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
      <mat-toolbar-row class="toolbar-row">
        <h1 i18n="Hosts List|Hosts List title@@hosts-list-title">Hosts</h1>

        <div class="fill-space"></div>

        <app-button label="Assign Host"
                    i18n-label="Hosts List|Assign Host button title@@hosts-assign-host-button-title"
                    color="primary"
                    [disabled]="!competition"
                    (clicked)="inviteHost(competition)"></app-button>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="content page">
      <div>
        <competition-select class="full-width"
                            (selected)="competitionSelected($event)"></competition-select>
      </div>

      <app-no-content *ngIf="!hosts"
                      [compact]="true"
                      title="Please select a competition from the list first"
                      i18n-title="Hosts List|Select competition prompt@@hosts-select-competition-prompt"
                      details="Hosts will be loaded for the selected competition"
                      i18n-details="Hosts List|Select competition prompt detail@@hosts-select-competition-prompt-detail">
      </app-no-content>
      <app-no-content *ngIf="hosts && !hosts.length"
                      [compact]="true"
                      title="Selected competition doesn't have any hosts assigned"
                      i18n-title="Hosts List|Selected competition no hosts title@@hosts-selected-competition-no-hosts">

        <app-button label="Assign Host"
                    i18n-label="Hosts List|Assign Host button title@@hosts-assign-host-button-title"
                    class="center create-cta"
                    [disabled]="!competition"
                    (clicked)="inviteHost(competition)"></app-button>
      </app-no-content>

      <mat-spinner *ngIf="inProgress" color="primary" diameter="50" class="center"></mat-spinner>

      <users-table *ngIf="competition && hosts" #usersTable
                   [users]="hosts"
                   [userRole]="HOST_ROLE"
                   [competitionId]="competition.id"
                   [editAllowed]="true"
                   [deleteAllowed]="true"
                   [showContact]="true"
                   (deleteRequested)="removeHost($event, usersTable)"
                   (userUpdated)="handleUpdatedUser($event)"></users-table>
    </div>
  </div>
</permission-checker>
